import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  deleteNotifications,
  insertFormsNotifications,
  updateNotifications,
} from 'src/store/notifications/actions';
import { NotificationGroups } from 'src/store/notifications/types';

const formRequestNotificationHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return insertFormsNotifications(
        items,
        NotificationGroups.FormRequestNotifications,
      );
    case EVENTS.MODIFY:
      return updateNotifications(
        items,
        NotificationGroups.FormRequestNotifications,
      );
    case EVENTS.REMOVE:
      return deleteNotifications(
        items,
        NotificationGroups.FormRequestNotifications,
      );
    default:
      break;
  }
  return null;
};

export default formRequestNotificationHandler;
